import osago from 'shared/assets/img/finances/osago.png';
import deposit8 from 'shared/assets/img/finances/deposit8.png';
import dms from 'shared/assets/img/finances/dms.png';
import property_insurance from 'shared/assets/img/finances/property_insurance.png';
import nsj from 'shared/assets/img/pages/card-plug.png';
import sjz from 'shared/assets/img/finances/sjz.png';
import debit_card from 'shared/assets/img/finances/debit_card.png';
import dsj from 'shared/assets/img/finances/dsj.png';
import investment from 'shared/assets/img/finances/investment.png';
import ipp from 'shared/assets/img/finances/ipp.png';
import credit10 from 'shared/assets/img/finances/credit10.png';

export const images: any = {
    osago: osago,
    deposit8: deposit8,
    dms: dms,
    property_insurance: property_insurance,
    nsj: nsj,
    sjz: sjz,
    debit_card: debit_card,
    dsj: dsj,
    investment: investment,
    ipp: ipp,
    credit10: credit10,
}
